import api from '@/api';

export type DataModuleId =
  | 'groups'
  | 'tags'
  | 'troves'
  | 'notes'
  | 'highlighter'
  | 'session'
  | 'sessionbookmark'
  | 'tasks'
  | 'tabs'
  | 'preference'
  | 'shares'
  | 'aiChunks'
  | 'aiUsageEvents';

export const ALL_DATA_MODULES: DataModuleId[] = [
  'groups',
  'tags',
  'troves',
  'notes',
  'highlighter',
  'session',
  'sessionbookmark',
  'tasks',
  'tabs',
  'preference',
  'shares',
  'aiChunks',
  'aiUsageEvents',
];

export interface ExportBundleV1 {
  version: number;
  exportedAt: number;
  accountId: string;
  exportedByUid: string;
  modules: DataModuleId[];
  data: Record<string, unknown>;
}

export type ImportMode = 'merge' | 'replace';

export interface ModuleResult {
  created: number;
  updated: number;
  skipped: number;
  deleted: number;
  errors: string[];
  warnings: string[];
}

export async function accountDataExport(modules: DataModuleId[]): Promise<ExportBundleV1> {
  const { data } = await api.post<{ status: string; bundle?: ExportBundleV1; message?: string }>('/data/export', {
    modules,
  });
  if (data.status !== 'success' || !data.bundle) {
    throw new Error(data.message ?? 'Export failed');
  }
  return data.bundle;
}

export async function accountDataImportPreflight(
  bundle: ExportBundleV1,
  modules: DataModuleId[]
): Promise<{
  status: string;
  ok?: boolean;
  warnings?: string[];
  summary?: Record<string, { approxDocs?: number; note?: string }>;
  bundleMeta?: { exportedAt: number; sourceAccountId: string; currentAccountId: string };
  message?: string;
}> {
  const { data } = await api.post('/data/import/preflight', { bundle, modules });
  return data;
}

export async function accountDataImportApply(
  bundle: ExportBundleV1,
  modules: DataModuleId[],
  mode: ImportMode,
  confirmReplace: boolean
): Promise<{
  status: string;
  mode?: ImportMode;
  report?: Record<string, ModuleResult>;
  message?: string;
}> {
  const { data } = await api.post('/data/import/apply', {
    bundle,
    modules,
    mode,
    confirmReplace,
  });
  return data;
}
